var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.26743 7.5L14.6335 2.13397C15.1222 1.64524 15.1222 0.855277 14.6335 0.366547C14.1447 -0.122182 13.3548 -0.122182 12.866 0.366547L7.5 5.73257L2.13397 0.366547C1.64524 -0.122182 0.855277 -0.122182 0.366547 0.366547C-0.122182 0.855277 -0.122182 1.64524 0.366547 2.13397L5.73257 7.5L0.366547 12.866C-0.122182 13.3548 -0.122182 14.1447 0.366547 14.6335C0.610287 14.8772 0.930274 14.9997 1.25026 14.9997C1.57025 14.9997 1.89023 14.8772 2.13397 14.6335L7.5 9.26743L12.866 14.6335C13.1098 14.8772 13.4298 14.9997 13.7497 14.9997C14.0697 14.9997 14.3897 14.8772 14.6335 14.6335C15.1222 14.1447 15.1222 13.3548 14.6335 12.866L9.26743 7.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.e66acd13.svg";
export { ForwardRef as ReactComponent };